import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-user-type',
    templateUrl: './user-type.component.html',
    styleUrls: ['./user-type.component.sass'],
    standalone: false
})

export class UserTypeComponent {

  @Input() icon_name: string ='';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  
}
